import Box from "@mui/material/Box";
import { BookButton } from "./BookButton";

export function StickyMobileBookButton({ onClick }) {
  return (
    <Box
      sx={{
        boxShadow: "0 -5px 40px 0 rgba(0, 0, 0, 0.14)",
        backgroundColor: "#ffffff",
      }}
      position="fixed"
      bottom={0}
      p="20px"
      width="100%"
    >
      <BookButton className="tw-w-full" color="yellow" onClick={onClick} />
    </Box>
  );
}
